import {
  Compass, Users, Building2, Cpu, Rocket, Layers, MapPin, Receipt, ShieldCheck,
  TrendingUp, HeartHandshake, BrainCircuit, CloudCog, Code2, Landmark, HeartPulse,
  GraduationCap, ShoppingCart, Factory, Briefcase, Lock, Gamepad2, Network, Eye,
  Route, Heart, Infinity as InfinityIcon,
} from "lucide-react";

const MAP = {
  Compass, Users, Building2, Cpu, Rocket, Layers, MapPin, Receipt, ShieldCheck,
  TrendingUp, HeartHandshake, BrainCircuit, CloudCog, Code2, Landmark, HeartPulse,
  GraduationCap, ShoppingCart, Factory, Briefcase, Lock, Gamepad2, Network, Eye,
  Route, Heart, Infinity: InfinityIcon,
};

export const Icon = ({ name, className = "h-6 w-6" }) => {
  const Cmp = MAP[name] || Compass;
  return <Cmp className={className} />;
};
